import { getGlobalData, setGlobalData } from './useGlobalData'

/** 购买数据信息 */
export const CACHE_TOPUP_INFO = 'GIFTCARD_TOPUP_INFO'
/** 卡信息 */
export const CACHE_CARD_INFO = 'GIFTCARD_CARD_INFO'
/** 卡信息 */
export const CACHE_CARD_TAB = 'CACHE_CARD_TAB'
/** 新手指引 */
export const CACHE_GUIDE = 'CACHE_NEW_GUIDE'
/** 业务来源 */
export const CACHE_BIZ_SOURCE = 'CACHE_BIZ_SOURCE'

/** 缓存支付结果信息 */
export function cacheTopupInfo(data: Record<string, any>) {
  setStorage(CACHE_TOPUP_INFO, data || {})
}

/** 清除支付结果缓存 */
export function getCacheTopupInfo() {
  return getStorage(CACHE_TOPUP_INFO, true) || {}
}

/** 缓存卡信息 */
export function cacheCardInfo(data: Record<string, any>) {
  setStorage(CACHE_CARD_INFO, data || {})
}

/** 清除卡信息缓存 */
export function getCacheCardInfo() {
  return getStorage(CACHE_CARD_INFO, true) || {}
}

/** 缓存卡列表tab */
export function cacheCardTab(data: Record<string, any>) {
  setStorage(CACHE_CARD_TAB, data || {})
}
/** 获取卡列表Tab */
export function getCardTab() {
  return getStorage(CACHE_CARD_TAB, true)
}

/** 缓存新人指引 */
export function cacheGuide(data: Record<string, any>) {
  setStorage(CACHE_GUIDE, data || {})
}

/** 获取新人指引 */
export function getGuideCache() {
  return getStorage(CACHE_GUIDE)
}

/** 缓存bizSource */
export function cacheBizSource(data: string) {
  setStorage(CACHE_BIZ_SOURCE, data)
}

/** 获取bizSource */
export function getBizSource() {
  return getStorage(CACHE_BIZ_SOURCE)
}

/** 获取bizSource */
export function clearCacheBizSource() {
  window?.localStorage?.setItem(CACHE_BIZ_SOURCE, '')
}

/** 设置本地存储 */
export function setStorage(key: string, data = {}) {
  try {
    // 设置全局变量
    setGlobalData(key, data)
    // 设置localStorage
    window.localStorage.setItem(key, JSON.stringify(data))
  } catch (error) {
    console.log(error)
  }
}

/** 获取本地存储 */
export function getStorage(key: string, clear?: boolean) {
  // 先从全局变量里获取
  let globalData = getGlobalData(key)
  if (globalData) return globalData
  // 全局变量里获取不到再从localStorage里获取
  try {
    const dataStr = window.localStorage.getItem(key)
    if (clear) {
      window.localStorage.setItem(key, '')
    }
    return dataStr ? JSON.parse(dataStr) : null
  } catch (error) {
    console.log(error)
  }
}
